/**
 * Entry point for the Botbakery Antonio embeddable chat widget
 *
 * This file is the entry point for the antonio widget build. It exports the
 * BotbakeryAntonioWidget API that can be used to embed Antonio-type instances'
 * guided chat flow on third-party websites.
 *
 * Usage:
 * ```html
 * <div id="antonio-widget"></div>
 * <script src="widget-antonio.umd.js"></script>
 * <script>
 *   BotbakeryAntonioWidget.init({
 *     apiKey: 'your-api-key',
 *     containerId: 'antonio-widget'
 *   });
 * </script>
 * ```
 */

// Import base styles (will be bundled into widget-antonio.css)
import '../src/standalone/widget-styles.scss';

import { BotbakeryAntonioWidget } from '../src/standalone/antonio/widget-antonio-init';

// Attach to window for UMD builds
if (typeof window !== 'undefined') {
	(window as any).BotbakeryAntonioWidget = BotbakeryAntonioWidget;
}

// Export for ESM builds
export { BotbakeryAntonioWidget };
export type { AntonioWidgetConfig } from '../src/standalone/antonio/widget-antonio-init';
